import SpaceBetween from "@cloudscape-design/components/space-between";
import {
  Box,
  Table,
  Button,
  TextFilter,
  Pagination,
  CollectionPreferences,
  ColumnLayout,
  Container,
  Header,
  Link,
  StatusIndicator,
  AppLayout,
  BreadcrumbGroup,
  ContentLayout,
  HelpPanel,
  Icon,
  SplitPanel,
  Spinner,
} from "@cloudscape-design/components";

import Grid from "@cloudscape-design/components/grid";
import Listunit from "./components/detail-table";
import { dataUnit } from "./data";
import Gmap from "./components/Gps-map";
import Alarmtab from "./components/alarm-table";
import Summary from "./components/Summary";
import { useEffect, useState } from "react";

import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import MapLibre from "./components/mapLibre";
import VehicleList from "./components/tyre-list-table";
import TyreList from "./components/tyre-list-table";
import { TyreTable } from "./components/data list tyre/data";
import { Navigation } from "../../../components/app/Navigation";
import React from "react";
import { listTyres } from "../../../graphql/queries";
import { ListTyresQueryVariables } from "../../../API";
import DashboardVehicle from "../../w_vehicle-page/dashboard-vehicle";
Amplify.configure(config);

interface DashboardTyreProps {
  onTotalTyreUpdate: (totalTyres: number) => void;
}


function DashboardTyre({ onTotalTyreUpdate }: DashboardTyreProps) {
  const [total_tyre, updateTotal_tyre] = useState(0);
  const [total_tyre_plug, updateTotal_tyreplug] = useState(0);
  const [total_tyre_unplug, updateTotal_tyreunplug] = useState(0);
  const [total_sensor, updateTotal_sensor] = useState(0);
  const [activeHref, setActiveHref] = React.useState("/vehicles/tyres/overview");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [listTyre, setListTyre] = useState<TyreTable[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  //graphql apis
  useEffect(() => {
    fetchOverview();
  }, []);

  

  async function fetchOverview(limit = 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allTyres: TyreTable[] = []; // Explicitly declare the type of allTyres
      let plugCount = 0; // Menyimpan jumlah ban terpasang
      let UnplugCount = 0; // Menyimpan jumlah ban tidak terpasang
  
      do {
        const variables: ListTyresQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listTyres,
          authMode: 'userPool',
          variables,
        });
  
        const tyress = response.data.listTyres.items;
        nextToken = response.data.listTyres.nextToken ?? null;
  
        const newTyres: TyreTable[] = tyress.map((tyre: any) => {
          const status = Boolean(tyre.status);
          
  
          // Hitung jumlah ban terpasang dan tidak terpasang
          if (status) {
            plugCount++;
          } else  {
            UnplugCount++;
          }
  
          return {
            id: tyre.id,
            tyreId: tyre.position ?? 0,
            sn: tyre.serialnumber ?? "",
            sensorId: tyre.sensorid ?? 0,
            brand: tyre.brand ?? "",
            typetyre: tyre.typetyre ?? "",
            VehicleCode: tyre.vehiclecode ?? "",
            pressure: tyre.pressure ?? 0,
            temperature: tyre.temperature ?? 0,
            battery: tyre.battery ?? 0,
            Status: status,
          };
        });
  
        allTyres = [...allTyres, ...newTyres];
      } while (nextToken);
  
      setListTyre(allTyres);
      updateTotal_tyre(allTyres.length);
      updateTotal_tyreplug(plugCount); // Jumlah ban terpasang
      updateTotal_tyreunplug(UnplugCount);
      onTotalTyreUpdate(allTyres.length); // Mengirim nilai total_tyre
      
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching todos: ", err);
    } finally {
      setIsLoading(false);
    }
  }
  
  return (
    <>
  
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              {
                text: "Tyres",
                href: "/vehicles/tyres",
              },
              {
                text: "Overview",
                href: "/vehicles/tyres/overview",
              },
            ]}
          />
        }
        
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/vehicles/tyres/overview" ? `Dashboard Tyre` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder'>
              <SpaceBetween size='l'>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, xxs: 4 } },
                    { colspan: { default: 12, xxs: 8 } },
                    { colspan: { default: 12, xxs: 12 } },
                  ]}
                >
                  <Container
                    header={
                      <Header variant='h2' description='Summary of total tyres'>
                        Overview
                      </Header>
                    }
                    fitHeight={true}
                  >
                    <ColumnLayout
                      columns={2}
                      variant='text-grid'
                      minColumnWidth={120}
                    >
                      <div style={{ marginTop: "20px" }}>
                        <Box variant='awsui-key-label'>Total Tyres</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Running instances (14)'
                        >
                          {total_tyre}
                        </Link>
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <Box variant='awsui-key-label'>Total Tyres Plug</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {total_tyre_plug}
                        </Link>
                      </div>
                    </ColumnLayout>
                    <div>
                      <ColumnLayout
                        columns={2}
                        variant='text-grid'
                        minColumnWidth={120}
                      >
                        <div style={{ marginTop: "50px" }}>
                          <Box variant='awsui-key-label'>Total Sensor</Box>
                          <Link
                            variant='awsui-value-large'
                            href='#'
                            ariaLabel='Running instances (14)'
                          >
                           {total_tyre}
                          </Link>
                        </div>
                        <div style={{ marginTop: "50px" }}>
                          <Box variant='awsui-key-label'>
                            Total Tyres Unplug
                          </Box>
                          <Link
                            variant='awsui-value-large'
                            href='#'
                            ariaLabel='Volumes (126)'
                          >
                            {total_tyre_unplug}
                          </Link>
                        </div>
                      </ColumnLayout>
                    </div>
                  </Container>
                  <Summary />
                  {/* <Gmap /> */}
                  {/*<MapLibre /> */}
                  {/* <TyreList TyreMaster={listTyre} /> */}
                  
                  {isLoading ? (
                     <Box textAlign="center" >
                     <Spinner size="large" />
                     <Box variant="p">Loading tyres data...</Box>
                   </Box>
                  ):<TyreList TyreMaster={listTyre} />}
                  
                </Grid>
              </SpaceBetween>
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}

export default DashboardTyre;

